import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f180a2f6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "promocode-wrapper d-flex fl-col fl-j-c fl-a-c"
};
var _hoisted_2 = {
  class: "inputs-wrapper",
  style: {
    "padding-top": "10%"
  }
};
var _hoisted_3 = {
  class: "d-flex flex-row fl-j-c"
};
var _hoisted_4 = {
  class: "input-container"
};
var _hoisted_5 = {
  class: "button-container"
};
var _hoisted_6 = {
  style: {
    "width": "80%",
    "margin": "auto",
    "height": "80%",
    "display": "flex",
    "flex-direction": "row"
  }
};
var _hoisted_7 = {
  style: {
    "margin-bottom": "4px"
  }
};
var _hoisted_8 = {
  style: {
    "margin-bottom": "4px"
  }
};
var _hoisted_9 = {
  style: {
    "margin-bottom": "4px"
  }
};
var _hoisted_10 = {
  style: {
    "margin-bottom": "4px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
    "input-style": "height: 80px; font-size: 26px;",
    placeholder: _ctx.inputPlaceholder,
    modelValue: _ctx.voucherCode,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.voucherCode = $event;
    })
  }, {
    suffix: _withCtx(function () {
      return [_createVNode(_component_el_icon, {
        class: "el-input__icon",
        style: {
          "height": "80px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_SvgIcon, {
            iconContent: _ctx.editPenIconContent,
            iconAlt: _ctx.editPenIconAlt,
            iconStyle: _ctx.editPenIconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["placeholder", "modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary",
    loading: _ctx.isLoading,
    class: "booking-button",
    "button-style": "height: 80px",
    onClick: _ctx.applyIncertVoucher,
    disabled: !_ctx.isPromocodeLengthValid
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.apply")), 1)];
    }),
    _: 1
  }, 8, ["loading", "onClick", "disabled"])])])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedVoucherInfos, function (voucherInfo) {
    return _openBlock(), _createElementBlock("div", {
      style: {
        "letter-spacing": "1px",
        "margin": "20px"
      },
      key: voucherInfo.voucherCode
    }, [_createElementVNode("p", _hoisted_7, "Code: " + _toDisplayString(voucherInfo.voucherCode), 1), _createElementVNode("p", _hoisted_8, "Status: " + _toDisplayString(voucherInfo.statusName), 1), _createElementVNode("p", _hoisted_9, " Remaining Value: " + _toDisplayString(voucherInfo.partiallyRedeemable ? voucherInfo.originalRemainingValue / 100 - voucherInfo.currentSessionVoucherConsumption / 100 + "" + voucherInfo.currency
    /* Not partially redeemable vouchers are consumed fully if user confirms */
    : 0.0 + "" + voucherInfo.currency), 1), _createElementVNode("p", _hoisted_10, " Partially redeemable: " + _toDisplayString(voucherInfo.partiallyRedeemable ? "Yes" : "No"), 1)]);
  }), 128))])]);
}